const LABS_API_BASE_URL = 'https://sefwod2sah.execute-api.us-west-2.amazonaws.com';
// TODO: replace with the production Reader API endpoint once it exists.
const PROD_API_BASE_URL_PLACEHOLDER = 'https://api.jeshua.ong';

const isLabsHost = (hostname) =>
  hostname === 'localhost' ||
  hostname === '127.0.0.1' ||
  hostname.startsWith('labs.');

export const getReaderApiBaseUrl = () => {
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
  return isLabsHost(hostname) ? LABS_API_BASE_URL : PROD_API_BASE_URL_PLACEHOLDER;
};

const request = async (method, path, { token, body } = {}) => {
  const headers = { Accept: 'application/json' };
  if (token) headers.Authorization = `Bearer ${token}`;
  if (body !== undefined) headers['Content-Type'] = 'application/json';

  try {
    const response = await fetch(`${getReaderApiBaseUrl()}${path}`, {
      method,
      headers,
      body: body !== undefined ? JSON.stringify(body) : undefined
    });
    const data = await response.json().catch(() => null);
    return { ok: response.ok, status: response.status, data };
  } catch (error) {
    return { ok: false, status: 0, data: null };
  }
};

export const apiGet = (path, options) => request('GET', path, options);
export const apiPost = (path, body, options) => request('POST', path, { ...options, body });
export const apiPut = (path, body, options) => request('PUT', path, { ...options, body });
export const apiDelete = (path, options) => request('DELETE', path, options);

export const getReaderEnvironment = () => {
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
  return isLabsHost(hostname) ? 'labs' : 'prod';
};
